// extracted by mini-css-extract-plugin
export default {"accordionContainer":"accordion_accordionContainer__4Lfnn","headerContainer":"accordion_headerContainer__Fmcdq"};